import { Component, OnChanges, Input, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
import { DvsChartComponent } from "src/app/shared/dvs-chart/dvs-chart.component";
import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-bearing-detail",
	templateUrl: "./bearing-detail.component.html",
	styleUrls: ["./bearing-detail.component.scss"],
	imports: [DvsChartComponent, FormsModule]
})
export class BearingDetailComponent implements OnChanges {
	private api = inject(ApiService);
	private charting = inject(ChartingService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	component: AssemblyConfig.Bearing;
	@Input()
	shaft: AssemblyConfig.Shaft;
	@Input()
	raw: APIResults.RawPairsResult;

	public spectrumoptions?: Highcharts.Options;
	public errormessage: string;
	public useorder = false;

	ngOnChanges() {
		this.UpdateChart();
	}
	async UpdateChart() {
		if (this.asset && this.component && this.raw) {
			this.spectrumoptions = undefined;
			this.errormessage = undefined;
			try {
				const result = await this.api.GetBearingVibe(this.asset.asset_id, this.component.id, this.raw.tachrawid, this.raw.viberawid, this.useorder);
				const markers = result.markers.map(marker => {
					return { title: marker.name, axisvalue: marker.value };
				});
				this.spectrumoptions = this.charting.SpectrumDefaults("Spectrum", "Gs", [
					{ type: "line", name: "Spectrum Analysis", data: result.spectrum },
				], this.useorder, markers);
			} catch (err) {
				this.errormessage = "Unable to load bearing vibe";
				console.error("Couldn't load bearing vibe");
				console.log(err);
			}
		}
	}
}
